export const messageFields = [
  {
    value: "id",
    label: "id",
    description: "Message ID",
  },
  {
    value: "message",
    label: "message",
    description: "Message text content",
  },
  {
    value: "messageLink",
    label: "messageLink",
    description: "Link to the message (t.me/ch/123...)",
  },
  {
    value: "date",
    label: "date",
    description: "Creation date",
  },
  {
    value: "pinned",
    label: "pinned",
    description: "Is message pinned",
  },
  {
    value: "views",
    label: "views",
    description: "View count",
  },
  {
    value: "forwards",
    label: "forwards",
    description: "Forward count",
  },
  {
    value: "fwdFrom",
    label: "fwdFrom",
    description: "Info about forwarded message",
  },
  {
    value: "viaBotId",
    label: "viaBotId",
    description: "ID of the inline bot that generated the message",
  },
  // {
  //   value: "replyTo",
  //   label: "Reply info",
  //   description: "Reply information",
  // },
  {
    value: "editDate",
    label: "editDate",
    description: "Last edit date of this message",
  },
  {
    value: "postAuthor",
    label: "postAuthor",
    description: "Name of the author of the message",
  },
  {
    value: "replies",
    label: "replies",
    description: "Info about post comments or replies",
  },
  {
    value: "groupedId",
    label: "groupedId",
    description: "ID of the album or media group inside message",
  },
  {
    value: "reactions",
    label: "reactions",
    description: "Reactions to the message",
  },
  {
    value: "post",
    label: "post",
    description: "Whether this is a channel post",
  },
  {
    value: "entities",
    label: "entities",
    description: "Text urls inside the message",
  },
  {
    value: "restrictionReason",
    label: "restrictionReason",
    description: "Reason of the message restriction (if restricted)",
  },
];
